<template lang="pug">
  .webchat-ui-custom-configuration
    .settings-container
      .header-config-container
        label {{ $t(`${BASE_TRANSLATION_PATH}.target`) }}
        .inline-label-box
          aiq-select(v-model="localWebchatUiCustomConfigs.channels" multiple placeholder="Select" :reserve-keyword="false")
            aiq-option(v-for="item in targetOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value")

    .settings-container
      .header-config-container
        .field-label
          span {{ $t(`${BASE_TRANSLATION_PATH}.header.section_title`) }}
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.header.mode`) }}
          .inline-label-box
            aiq-select(v-model="localWebchatUiCustomConfigs.header.mode"
              size="small")
              aiq-option(
                v-for="option in headerModeOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.header.title`) }}
          .inline-label-box
            aiq-input(v-model="localWebchatUiCustomConfigStrings.header.custom.title"
              size="small")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.header.logo`) }}
          .inline-label-box(v-if="localWebchatUiCustomConfigs.header.custom.logo_url")
            aiq-image.icon-preview(
              :src="localWebchatUiCustomConfigs.header.custom.logo_url"
              :key="localWebchatUiCustomConfigs.header.custom.logo_url")
          .inline-label-box
            .upload-button
              aiq-upload.no-margin(
                v-model="localWebchatUiCustomConfigs.header.custom.logo_url"
                :http-request="upload()"
                :action="uploadUrl"
                accept="image/*"
                :headers="headers"
                :show-file-list="false"
                :disabled="!uploadEnabled"
                :on-success="(res) => onHandleUploadSuccess(res, ['header', 'custom', 'logo_url'])"
                ref="headerLogoUploader")
                aiq-button.upload-btn(size="small" :disabled="!uploadEnabled") {{ $t(`global.upload`) }}
              aiq-button.delete-btn(
                v-if="localWebchatUiCustomConfigs.header.custom.logo_url"
                size="small"
                type="danger"
                @click="cleanHeaderLogo") {{ $t(`global.delete`) }}

    .settings-container
      .header-config-container
        .field-label
          span {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.section_title`) }}
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.time_display`) }}
          .inline-label-box
            aiq-select(v-model="localWebchatUiCustomConfigs.agent_message.time_display"
              size="small")
              aiq-option(
                v-for="option in timeDisplayOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.timestamp_position`) }}
          .inline-label-box
            aiq-select(v-model="localWebchatUiCustomConfigs.agent_message.timestamp_position"
              size="small")
              aiq-option(
                v-for="option in timestampPositionOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.timestamp_alignment`) }}
          .inline-label-box
            aiq-select(v-model="localWebchatUiCustomConfigs.agent_message.timestamp_alignment"
              size="small")
              aiq-option(
                v-for="option in timestampAlignmentOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value")
        .sub-field
          .field-label.field-label--with-switch
            span {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.show_avatar`) }}
            aiq-switch.margin-left-10(v-model="localWebchatUiCustomConfigs.agent_message.show_avatar")
        template(v-if="localWebchatUiCustomConfigs.agent_message.show_avatar")
          .sub-field.sub-field--nested
            .field-label.field-label--with-switch
              span {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.use_profile_image`) }}
              aiq-switch.margin-left-10(v-model="localWebchatUiCustomConfigs.agent_message.use_profile_image")
          template(v-if="!localWebchatUiCustomConfigs.agent_message.use_profile_image")
            .sub-field.sub-field--nested
              label {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.custom_avatar_icon_url`) }}
              .inline-label-box(v-if="localWebchatUiCustomConfigs.agent_message.custom_avatar_icon_url")
                aiq-image.icon-preview(
                  :src="localWebchatUiCustomConfigs.agent_message.custom_avatar_icon_url"
                  :key="localWebchatUiCustomConfigs.agent_message.custom_avatar_icon_url")
              .inline-label-box
                .upload-button
                  aiq-upload.no-margin(
                    v-model="localWebchatUiCustomConfigs.agent_message.custom_avatar_icon_url"
                    :http-request="upload()"
                    :action="uploadUrl"
                    accept="image/*"
                    :headers="headers"
                    :show-file-list="false"
                    :disabled="!uploadEnabled"
                    :on-success="(res) => onHandleUploadSuccess(res, ['agent_message', 'custom_avatar_icon_url'])"
                    ref="customAvatarIconUploader")
                    aiq-button.upload-btn(size="small" :disabled="!uploadEnabled") {{ $t(`global.upload`) }}
                  aiq-button.delete-btn(
                    v-if="localWebchatUiCustomConfigs.agent_message.custom_avatar_icon_url"
                    size="small"
                    type="danger"
                    @click="cleanCustomAvatarIcon") {{ $t(`global.delete`) }}
        .sub-field
          .field-label.field-label--with-switch
            span {{ $t(`${BASE_TRANSLATION_PATH}.agent_message.show_agent_name`) }}
            aiq-switch.margin-left-10(v-model="localWebchatUiCustomConfigs.agent_message.show_agent_name")

    .settings-container
      .header-config-container
        .field-label
          span {{ $t(`${BASE_TRANSLATION_PATH}.customer_message.section_title`) }}
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.customer_message.time_display`) }}
          .inline-label-box
            aiq-select(v-model="localWebchatUiCustomConfigs.customer_message.time_display"
              size="small")
              aiq-option(
                v-for="option in timeDisplayOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.customer_message.timestamp_position`) }}
          .inline-label-box
            aiq-select(v-model="localWebchatUiCustomConfigs.customer_message.timestamp_position"
              size="small")
              aiq-option(
                v-for="option in timestampPositionOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.customer_message.timestamp_alignment`) }}
          .inline-label-box
            aiq-select(v-model="localWebchatUiCustomConfigs.customer_message.timestamp_alignment"
              size="small")
              aiq-option(
                v-for="option in timestampAlignmentOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value")
        .sub-field
          .field-label.field-label--with-switch
            span {{ $t(`${BASE_TRANSLATION_PATH}.customer_message.show_avatar`) }}
            aiq-switch.margin-left-10(v-model="localWebchatUiCustomConfigs.customer_message.show_avatar")

    .settings-container
      .header-config-container.header-config-container--split
        .field-label.field-label--table-header
          span {{ $t(`${BASE_TRANSLATION_PATH}.custom_system_messages.section_title`) }}
          aiq-button(size="small" type="primary" @click="addCustomSystemMessageRow") {{ $t(`global.add`) }}
        aiq-table.custom-system-messages-table(:data="localWebchatUiCustomConfigs.custom_system_messages")
          aiq-table-column(:label="$t(`${BASE_TRANSLATION_PATH}.custom_system_messages.name`)" min-width="140")
            template(v-slot:default="scope")
              .custom-system-message-name-field(
                :class="{'is-error': customSystemMessageNameErrors[scope.$index]}")
                aiq-input(
                  :model-value="scope.row.name"
                  size="small"
                  @update:model-value="(value) => onCustomSystemMessageNameChange(scope.row, scope.$index, value)")
                span.custom-system-message-name-field__error(
                  v-if="customSystemMessageNameErrors[scope.$index]") {{ customSystemMessageNameErrors[scope.$index] }}
          aiq-table-column(:label="$t(`${BASE_TRANSLATION_PATH}.custom_system_messages.message`)" min-width="220")
            template(v-slot:default="scope")
              aiq-input(
                v-model="localWebchatUiCustomConfigStrings.custom_system_messages[scope.row.message_langkey]"
                size="small"
                :disabled="!scope.row.message_langkey")
          aiq-table-column(:label="$t(`${BASE_TRANSLATION_PATH}.custom_system_messages.triggered_condition.column_label`)" min-width="180")
            template(v-slot:default="scope")
              aiq-select(
                v-model="scope.row.triggered_condition"
                size="small"
                :disabled="!scope.row.message_langkey")
                aiq-option(
                  v-for="option in customSystemMessageDisplayOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value")
          aiq-table-column(label="" width="100")
            template(v-slot:default="scope")
              aiq-button(type="danger" size="small" @click="removeCustomSystemMessageRow(scope.$index)") {{ $t(`global.delete`) }}


    .settings-container
      .header-config-container
        .field-label
          span {{ $t(`${BASE_TRANSLATION_PATH}.input_box.section_title`) }}
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.input_box.branding_text`) }}
          .inline-label-box
            aiq-input(v-model="localWebchatUiCustomConfigStrings.input_box.branding_text"
              size="small")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.input_box.placeholder_text`) }}
          .inline-label-box
            aiq-input(v-model="localWebchatUiCustomConfigStrings.input_box.placeholder_text"
              size="small")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.input_box.text_limit`) }}
          .inline-label-box
            aiq-input(v-model.number="localWebchatUiCustomConfigs.input_box.text_limit"
              size="small"
              type="number"
              min="0"
              :max="INPUT_BOX_TEXT_LIMIT_MAX")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.input_box.upload_button_icon`) }}
          .inline-label-box(v-if="localWebchatUiCustomConfigs.input_box.upload_button_icon_url")
            aiq-image.icon-preview(
              :src="localWebchatUiCustomConfigs.input_box.upload_button_icon_url"
              :key="localWebchatUiCustomConfigs.input_box.upload_button_icon_url")
          .inline-label-box
            .upload-button
              aiq-upload.no-margin(
                v-model="localWebchatUiCustomConfigs.input_box.upload_button_icon_url"
                :http-request="upload()"
                :action="uploadUrl"
                accept="image/*"
                :headers="headers"
                :show-file-list="false"
                :disabled="!uploadEnabled"
                :on-success="(res) => onHandleUploadSuccess(res, ['input_box', 'upload_button_icon_url'])"
                ref="uploadButtonIconUploader")
                aiq-button.upload-btn(size="small" :disabled="!uploadEnabled") {{ $t(`global.upload`) }}
              aiq-button.delete-btn(
                v-if="localWebchatUiCustomConfigs.input_box.upload_button_icon_url"
                size="small"
                type="danger"
                @click="cleanUploadButtonIcon") {{ $t(`global.delete`) }}
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.input_box.send_button_icon`) }}
          .inline-label-box(v-if="localWebchatUiCustomConfigs.input_box.send_button_icon_url")
            aiq-image.icon-preview(
              :src="localWebchatUiCustomConfigs.input_box.send_button_icon_url"
              :key="localWebchatUiCustomConfigs.input_box.send_button_icon_url")
          .inline-label-box
            .upload-button
              aiq-upload.no-margin(
                v-model="localWebchatUiCustomConfigs.input_box.send_button_icon_url"
                :http-request="upload()"
                :action="uploadUrl"
                accept="image/*"
                :headers="headers"
                :show-file-list="false"
                :disabled="!uploadEnabled"
                :on-success="(res) => onHandleUploadSuccess(res, ['input_box', 'send_button_icon_url'])"
                ref="sendButtonIconUploader")
                aiq-button.upload-btn(size="small" :disabled="!uploadEnabled") {{ $t(`global.upload`) }}
              aiq-button.delete-btn(
                v-if="localWebchatUiCustomConfigs.input_box.send_button_icon_url"
                size="small"
                type="danger"
                @click="cleanSendButtonIcon") {{ $t(`global.delete`) }}

    .settings-container
      .header-config-container
        .field-label
          span {{ $t(`${BASE_TRANSLATION_PATH}.hamburger_menu.section_title`) }}
        .sub-field
          .field-label.field-label--with-switch
            span {{ $t(`${BASE_TRANSLATION_PATH}.hamburger_menu.header_visibility`) }}
            aiq-switch.margin-left-10(v-model="localWebchatUiCustomConfigs.hamburger_menu.enabled")
        .sub-field
          label {{ $t(`${BASE_TRANSLATION_PATH}.hamburger_menu.close_conversation`) }}
          .inline-label-box
            aiq-input(v-model="localWebchatUiCustomConfigStrings.hamburger_menu.close_conversation.label"
              size="small")

    .settings-container
      .settings__item
        .save-buttons__container.settings__item
          aiq-button(:disabled="isWebchatUiCustomConfigurationPristine" @click="resetWebchatUiCustomConfiguration") {{ $t(`global.cancel`) }}
          aiq-button.save__button(
            type="primary"
            :disabled="isWebchatUiCustomConfigurationPristine || hasCustomSystemMessageNameErrors"
            @click="saveWebchatUiCustomConfiguration") {{ $t(`global.save`) }}
</template>

<script>
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import set from 'lodash/set';
import { hosts } from '@/config/api.routes';
import {
  DEFAULT_WEBCHAT_UI_AGENT_MESSAGE,
  DEFAULT_WEBCHAT_UI_CUSTOM_SYSTEM_MESSAGE,
  DEFAULT_WEBCHAT_UI_CUSTOMER_MESSAGE,
  DEFAULT_WEBCHAT_UI_HAMBURGER_MENU,
  DEFAULT_WEBCHAT_UI_HEADER,
  DEFAULT_WEBCHAT_UI_INPUT_BOX,
  HAMBURGER_MENU_SELECTION_OPTIONS,
  INPUT_BOX_TEXT_LIMIT_MAX,
} from '@/constants/settings';

const CUSTOM_SYSTEM_MESSAGE_LANG_KEY_PREFIX = 'webchat.custom_system_messages';

const getCustomSystemMessageLangKey = (name) => {
  const trimmedName = name?.trim();
  if (!trimmedName) {
    return '';
  }

  return `${CUSTOM_SYSTEM_MESSAGE_LANG_KEY_PREFIX}.${trimmedName}`;
};

const sortCustomSystemMessagesByName = (rows) => {
  return [...rows].sort((a, b) => (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase()));
};

const WEBCHAT_UI_CUSTOM_CONFIG_STRING_LANG_KEY_MAP = {
  'input_box.branding_text': 'input_box.branding_text_langkey',
  'input_box.placeholder_text': 'input_box.placeholder_text_langkey',
  'header.custom.title': 'header.custom.title_langkey',
  'hamburger_menu.close_conversation.label': 'hamburger_menu.close_conversation.label_langkey',
};

export default {
  name: 'webchat-ui-custom-configuration',
  props: {
    configs: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['save'],
  data() {
    return {
      BASE_TRANSLATION_PATH: 'settings_tab.channels_tab.webchat_ui.webchat_ui_custom_configuration',
      INPUT_BOX_TEXT_LIMIT_MAX,
      localWebchatUiCustomConfigs: this.cloneLocalWebchatUiCustomConfigs(this.configs),
      localWebchatUiCustomConfigStrings: this.cloneLocalWebchatUiCustomConfigStrings(
        this.webchatLanguageStrings || {},
        this.configs,
      ),
      uploadUrl: `${hosts.management}files/upload`,
      uploadEnabled: true,
      targetOptions: cloneDeep(HAMBURGER_MENU_SELECTION_OPTIONS),
      headers: {
        Authorization: this.$store.getters['agent/authToken'],
      },
      customSystemMessageNameErrors: {},
    };
  },
  computed: {
    ...mapState({
      webchatLanguageStrings: state => state.configs.language_strings,
    }),
    isWebchatUiCustomConfigurationPristine() {
      const baselineConfigs = this.cloneLocalWebchatUiCustomConfigs(this.configs);
      const baselineStrings = this.cloneLocalWebchatUiCustomConfigStrings(
        this.webchatLanguageStrings || {},
        baselineConfigs,
      );

      return isEqual(
        get(this.localWebchatUiCustomConfigs, 'channels', []),
        get(baselineConfigs, 'channels', []),
      ) && isEqual(
        get(this.localWebchatUiCustomConfigs, 'header', {}),
        get(baselineConfigs, 'header', {}),
      ) && isEqual(
        get(this.localWebchatUiCustomConfigs, 'agent_message', {}),
        get(baselineConfigs, 'agent_message', {}),
      ) && isEqual(
        get(this.localWebchatUiCustomConfigs, 'customer_message', {}),
        get(baselineConfigs, 'customer_message', {}),
      ) && isEqual(
        get(this.localWebchatUiCustomConfigs, 'input_box', {}),
        get(baselineConfigs, 'input_box', {}),
      ) && isEqual(
        get(this.localWebchatUiCustomConfigs, 'custom_system_messages', []),
        get(baselineConfigs, 'custom_system_messages', []),
      ) && isEqual(
        get(this.localWebchatUiCustomConfigs, 'hamburger_menu', {}),
        get(baselineConfigs, 'hamburger_menu', {}),
      ) && isEqual(this.localWebchatUiCustomConfigStrings, baselineStrings);
    },
    hasCustomSystemMessageNameErrors() {
      return Object.keys(this.customSystemMessageNameErrors).length > 0;
    },
    timeDisplayOptions() {
      return [
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.agent_message.time_display_relative`),
          value: 'relative',
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.agent_message.time_display_absolute`),
          value: 'absolute',
        },
      ];
    },
    timestampPositionOptions() {
      return [
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.agent_message.timestamp_position_inside`),
          value: 'inside',
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.agent_message.timestamp_position_outside`),
          value: 'outside',
        },
      ];
    },
    timestampAlignmentOptions() {
      return [
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.agent_message.timestamp_alignment_left`),
          value: 'left',
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.agent_message.timestamp_alignment_right`),
          value: 'right',
        },
      ];
    },
    headerModeOptions() {
      return [
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.header.mode_default`),
          value: 'default',
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.header.mode_custom`),
          value: 'custom',
        },
      ];
    },
    customSystemMessageDisplayOptions() {
      return [
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.custom_system_messages.triggered_condition.options.always`),
          value: 'always',
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.custom_system_messages.triggered_condition.options.active_conversation`),
          value: 'active_conversation',
        },
        {
          label: this.$t(`${this.BASE_TRANSLATION_PATH}.custom_system_messages.triggered_condition.options.closed_conversation`),
          value: 'closed_conversation',
        },
      ];
    },
  },
  mounted() {
    this.refreshCustomSystemMessageNameErrors();
  },
  watch: {
    configs(newVal) {
      this.localWebchatUiCustomConfigs = this.cloneLocalWebchatUiCustomConfigs(newVal);
      this.localWebchatUiCustomConfigStrings = this.cloneLocalWebchatUiCustomConfigStrings(
        this.webchatLanguageStrings || {},
        newVal,
      );
      this.refreshCustomSystemMessageNameErrors();
    },
    webchatLanguageStrings: {
      handler(newVal) {
        this.localWebchatUiCustomConfigStrings = this.cloneLocalWebchatUiCustomConfigStrings(
          newVal || {},
          this.localWebchatUiCustomConfigs,
        );
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    cloneLocalWebchatUiCustomConfigs(newConfig) {
      const cfg = cloneDeep(newConfig || {});
      const channels = get(cfg, 'channels', []);
      set(cfg, 'channels', Array.isArray(channels) ? [...channels] : []);
      set(cfg, 'header', { ...cloneDeep(DEFAULT_WEBCHAT_UI_HEADER), ...get(cfg, 'header', {}) });
      set(cfg, 'agent_message', { ...cloneDeep(DEFAULT_WEBCHAT_UI_AGENT_MESSAGE), ...get(cfg, 'agent_message', {}) });
      set(cfg, 'customer_message', { ...cloneDeep(DEFAULT_WEBCHAT_UI_CUSTOMER_MESSAGE), ...get(cfg, 'customer_message', {}) });
      set(cfg, 'input_box', { ...cloneDeep(DEFAULT_WEBCHAT_UI_INPUT_BOX), ...get(cfg, 'input_box', {}) });
      const customSystemMessages = get(cfg, 'custom_system_messages', []);
      set(
        cfg,
        'custom_system_messages',
        Array.isArray(customSystemMessages)
          ? sortCustomSystemMessagesByName(
            customSystemMessages.map(row => {
              const mergedRow = { ...DEFAULT_WEBCHAT_UI_CUSTOM_SYSTEM_MESSAGE, ...row };
              if (mergedRow.name?.trim()) {
                mergedRow.message_langkey = getCustomSystemMessageLangKey(mergedRow.name);
              }
              return mergedRow;
            }),
          )
          : [],
      );
      set(cfg, 'hamburger_menu', { ...cloneDeep(DEFAULT_WEBCHAT_UI_HAMBURGER_MENU), ...get(cfg, 'hamburger_menu', {}) });
      return cfg;
    },
    cloneLocalWebchatUiCustomConfigStrings(languageStringsRoot, configs) {
      const sourceConfigs = configs || this.localWebchatUiCustomConfigs;
      const cfgStrings = {};
      Object.keys(WEBCHAT_UI_CUSTOM_CONFIG_STRING_LANG_KEY_MAP).forEach(key => {
        const langKeyPath = WEBCHAT_UI_CUSTOM_CONFIG_STRING_LANG_KEY_MAP[key];
        const pathInLocaleFile = get(sourceConfigs, langKeyPath, '');
        const localeString = typeof pathInLocaleFile === 'string' && pathInLocaleFile.length > 0
          ? get(languageStringsRoot, pathInLocaleFile, '')
          : '';
        set(cfgStrings, key, localeString);
      });
      const customSystemMessages = get(sourceConfigs, 'custom_system_messages', []);
      const customSystemMessageStrings = {};
      if (Array.isArray(customSystemMessages)) {
        customSystemMessages.forEach(row => {
          if (!row?.message_langkey) {
            return;
          }
          customSystemMessageStrings[row.message_langkey] = get(
            languageStringsRoot,
            row.message_langkey,
            '',
          );
        });
      }
      set(cfgStrings, 'custom_system_messages', customSystemMessageStrings);
      return cfgStrings;
    },
    buildWebchatUiCustomConfigPayload() {
      const payload = Object.keys(WEBCHAT_UI_CUSTOM_CONFIG_STRING_LANG_KEY_MAP).reduce((acc, key) => {
        const langKeyPath = get(
          this.localWebchatUiCustomConfigs,
          WEBCHAT_UI_CUSTOM_CONFIG_STRING_LANG_KEY_MAP[key],
          '',
        );
        if (!langKeyPath) {
          return acc;
        }
        set(acc, langKeyPath, get(this.localWebchatUiCustomConfigStrings, key, ''));
        return acc;
      }, {});
      const customSystemMessages = get(this.localWebchatUiCustomConfigs, 'custom_system_messages', []);
      customSystemMessages.forEach(row => {
        if (!row?.name?.trim() || !row?.message_langkey) {
          return;
        }
        set(
          payload,
          row.message_langkey,
          get(this.localWebchatUiCustomConfigStrings, ['custom_system_messages', row.message_langkey], ''),
        );
      });
      return payload;
    },
    refreshCustomSystemMessageNameErrors() {
      const rows = get(this.localWebchatUiCustomConfigs, 'custom_system_messages', []);
      const errors = {};
      const uniqueError = this.$t(`${this.BASE_TRANSLATION_PATH}.custom_system_messages.name_already_exists`);

      rows.forEach((row, index) => {
        const name = row.name?.trim();
        if (!name) {
          return;
        }

        const isDuplicate = rows.some((otherRow, otherIndex) => (
          otherIndex !== index && otherRow.name?.trim().toLowerCase() === name.toLowerCase()
        ));
        if (isDuplicate) {
          errors[index] = uniqueError;
        }
      });

      this.customSystemMessageNameErrors = errors;
    },
    isDuplicateCustomSystemMessageName(name, rowIndex) {
      const trimmedName = name?.trim();
      if (!trimmedName) {
        return false;
      }

      return get(this.localWebchatUiCustomConfigs, 'custom_system_messages', [])
        .some((otherRow, otherIndex) => (
          otherIndex !== rowIndex && otherRow.name?.trim().toLowerCase() === trimmedName.toLowerCase()
        ));
    },
    onCustomSystemMessageNameChange(row, rowIndex, value) {
      const nextValue = value.toLowerCase().replace(/[^a-z0-9._-]/g, '');
      const trimmedValue = nextValue.trim();
      row.name = trimmedValue;

      if (!this.isDuplicateCustomSystemMessageName(trimmedValue, rowIndex)) {
        const previousLangKey = row.message_langkey;
        this.syncCustomSystemMessageLangKey(row, previousLangKey, getCustomSystemMessageLangKey(trimmedValue));
      }

      this.refreshCustomSystemMessageNameErrors();
    },
    syncCustomSystemMessageLangKey(row, previousLangKey, nextLangKey) {
      const customSystemMessageStrings = {
        ...get(this.localWebchatUiCustomConfigStrings, 'custom_system_messages', {}),
      };
      const messageValue = previousLangKey ? customSystemMessageStrings[previousLangKey] : '';

      if (previousLangKey && previousLangKey !== nextLangKey) {
        delete customSystemMessageStrings[previousLangKey];
      }

      row.message_langkey = nextLangKey;
      if (nextLangKey) {
        customSystemMessageStrings[nextLangKey] = messageValue ?? '';
      }

      set(this.localWebchatUiCustomConfigStrings, 'custom_system_messages', customSystemMessageStrings);
    },
    addCustomSystemMessageRow() {
      const hasEmptyNameRow = get(this.localWebchatUiCustomConfigs, 'custom_system_messages', [])
        .some(row => !row?.name?.trim());
      if (hasEmptyNameRow) {
        return;
      }

      this.localWebchatUiCustomConfigs.custom_system_messages.push({ ...DEFAULT_WEBCHAT_UI_CUSTOM_SYSTEM_MESSAGE });
    },
    async deleteCustomSystemMessageConfirm() {
      try {
        await this.$aiq.confirm(
          this.$t(`${this.BASE_TRANSLATION_PATH}.custom_system_messages.delete_confirm.title`),
          this.$t(`${this.BASE_TRANSLATION_PATH}.custom_system_messages.delete_confirm.message`),
          {
            cancelButtonText: this.$t('global.cancel'),
            confirmButtonText: this.$t('global.ok'),
          },
        );
        return true;
      } catch {
        return false;
      }
    },
    getCustomSystemMessageText(row) {
      if (!row?.message_langkey) {
        return '';
      }

      const customSystemMessageStrings = get(this.localWebchatUiCustomConfigStrings, 'custom_system_messages', {});
      return get(customSystemMessageStrings, row.message_langkey, '').trim();
    },
    async removeCustomSystemMessageRow(index) {
      const row = this.localWebchatUiCustomConfigs.custom_system_messages[index];
      if (!row) {
        return;
      }

      const hasName = Boolean(row.name?.trim());
      const hasMessage = Boolean(this.getCustomSystemMessageText(row));
      if (hasName || hasMessage) {
        const confirmed = await this.deleteCustomSystemMessageConfirm();
        if (!confirmed) {
          return;
        }
      }

      if (row.message_langkey) {
        const customSystemMessageStrings = {
          ...get(this.localWebchatUiCustomConfigStrings, 'custom_system_messages', {}),
        };
        delete customSystemMessageStrings[row.message_langkey];
        set(this.localWebchatUiCustomConfigStrings, 'custom_system_messages', customSystemMessageStrings);
      }

      this.localWebchatUiCustomConfigs.custom_system_messages.splice(index, 1);
      this.refreshCustomSystemMessageNameErrors();
    },
    upload() {
      return async(data) => {
        this.uploadEnabled = false;
        try {
          return await this.$store.dispatch('files/uploadPublicManagementFile', { file: data.file });
        } catch (err) {
          this.onUploadFailed(get(err, 'response.data.error'));
        }
      };
    },
    onHandleUploadSuccess(res, urlPath) {
      if (!res?.url) {
        return this.onUploadFailed();
      }
      set(this.localWebchatUiCustomConfigs, urlPath, res.url);
      this.resetUploading();
      this.$aiq.notify.success('Successful');
    },
    onUploadFailed(errorMsg = 'Failed') {
      this.$aiq.notify.error(errorMsg);
      this.resetUploading();
      this.$refs.customAvatarIconUploader && this.$refs.customAvatarIconUploader.clearFiles();
      this.$refs.headerLogoUploader && this.$refs.headerLogoUploader.clearFiles();
      this.$refs.uploadButtonIconUploader && this.$refs.uploadButtonIconUploader.clearFiles();
      this.$refs.sendButtonIconUploader && this.$refs.sendButtonIconUploader.clearFiles();
    },
    resetUploading() {
      this.uploadEnabled = true;
    },
    cleanCustomAvatarIcon() {
      this.localWebchatUiCustomConfigs.agent_message.custom_avatar_icon_url = '';
    },
    cleanHeaderLogo() {
      this.localWebchatUiCustomConfigs.header.custom.logo_url = '';
    },
    cleanUploadButtonIcon() {
      this.localWebchatUiCustomConfigs.input_box.upload_button_icon_url = '';
    },
    cleanSendButtonIcon() {
      this.localWebchatUiCustomConfigs.input_box.send_button_icon_url = '';
    },
    resetWebchatUiCustomConfiguration() {
      this.localWebchatUiCustomConfigs = this.cloneLocalWebchatUiCustomConfigs(this.configs);
      this.localWebchatUiCustomConfigStrings = this.cloneLocalWebchatUiCustomConfigStrings(
        this.webchatLanguageStrings || {},
        this.configs,
      );
      this.customSystemMessageNameErrors = {};
      this.refreshCustomSystemMessageNameErrors();
    },
    saveWebchatUiCustomConfiguration() {
      this.refreshCustomSystemMessageNameErrors();
      if (this.hasCustomSystemMessageNameErrors) {
        return;
      }

      // Validate text limit
      if (!Number.isFinite(this.localWebchatUiCustomConfigs.input_box.text_limit)
        || this.localWebchatUiCustomConfigs.input_box.text_limit < 0
        || this.localWebchatUiCustomConfigs.input_box.text_limit > INPUT_BOX_TEXT_LIMIT_MAX
      ) {
        this.localWebchatUiCustomConfigs.input_box.text_limit = INPUT_BOX_TEXT_LIMIT_MAX;
      }
      const webchatUiCustomConfig = cloneDeep(this.localWebchatUiCustomConfigs);
      webchatUiCustomConfig.custom_system_messages = get(webchatUiCustomConfig, 'custom_system_messages', [])
        .filter(row => row?.name?.trim())
        .map(({ name, message_langkey, triggered_condition }) => ({ name, message_langkey, triggered_condition }));

      this.$emit('save', {
        webchatUiCustomConfig,
        configStrings: this.buildWebchatUiCustomConfigPayload(),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/aiq-variables.scss";

.webchat-ui-custom-configuration {
  * {
    margin: 5px 0px;
  }

  .no-margin {
    margin: 0px;
    padding-right: 10px;
  }

  .settings-container {
    display: flex;

    .settings__item {
      align-self: flex-start;
      flex-grow: 1;
      min-width: 589px;
    }
  }

  .header-config-container {
    width: 482px;

    .field-label {
      color: #475669;
      font-family: $aiq-font-family;
      font-size: 14px;
      font-weight: 300;
      letter-spacing: 0;

      &--with-switch {
        align-items: center;
        display: grid;
        gap: 8px;
        grid-template-columns: 220px auto;
      }
    }

    .sub-field {
      padding-left: 14px;

      &--nested {
        padding-left: 28px;

        .field-label--with-switch {
          grid-template-columns: 206px auto;
        }
      }
    }

    &--split {
      max-width: 980px;
      width: 100%;
    }
  }

  .field-label {
    &--table-header {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }
  }

  .inline-label-box {
    display: flex;
  }

  .upload-button {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .save-buttons__container {
    background-color: var(--aiq-color-white);
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    left: 0;
    margin-bottom: 0px;
    padding: 5px 8px 0px 0px;
    width: calc(100% - 4px);

    * {
      margin: 0px 5px;
    }

    .save__button {
      margin-right: 0px;
    }
  }

  .icon-preview {
    max-height: 40px;
    max-width: 40px;
  }

  .custom-system-messages-table {
    margin-top: 8px;
    height: auto !important;

    :deep(.el-table__cell) {
      border-color: transparent !important;
      vertical-align: top !important;
      padding: 3px 5px;
    }
  }

  .custom-system-message-name-field {
    display: flex;
    flex-direction: column;
    margin: 0;

    &.is-error {
      :deep(.el-input__inner) {
        border-color: $aiq-color-error !important;
      }
    }

    &__error {
      color: $aiq-color-error;
      font-size: 12px;
      margin-top: 0px;
    }
  }
}
</style>
